import React, { useEffect, useRef, useState } from "react"
import { Spinner } from "reactstrap"
import { get } from "helpers/api_helper"
import { lineLabel } from "./generationLabels"
import { proposedCompetition } from "./proposalForm"

// „Propose competitions” (wayfinder ticket 11; D3's editor read): the previous edition's competitions the proposal does not hold yet, sized
// by their demand (= ↑ ↓, ✕ proposed for removal), and the area's suggestions (+), each with its rule and numbers. It adds, never replaces;
// the lines chosen are saved with the editor's Save. Lines read for values changed since are not offered (CP lesson 2026-09-30).
export default function ProposeCompetitions({ path, disabledReason, disabled, onAdd }) {
  const [state, setState] = useState(null)
  const [ticks, setTicks] = useState({})
  const mounted = useRef(true)
  useEffect(() => () => { mounted.current = false }, [])
  const open = async () => {
    const asked = path
    setState({ loading: true })
    try {
      const response = await get(asked)
      if (!mounted.current) return
      const lines = [...(response?.data?.competitions || []), ...(response?.data?.suggested || [])]
      setTicks(Object.fromEntries(lines.map(line => [line.id, line.ticked])))
      setState({ lines, path: asked })
    } catch (error) {
      if (mounted.current) setState({ error: "The competitions could not be proposed. Try again." })
    }
  }
  const chosen = (state?.lines || []).filter(line => ticks[line.id])
  if (!state || state.error) {
    return <div className="ep-stack">
      <button type="button" className="btn btn-light align-self-start" disabled={disabled || Boolean(disabledReason)} onClick={open}>
        <i className="bx bx-bulb" aria-hidden="true" /> Propose competitions</button>
      {disabledReason && <small className="ep-meta">{disabledReason}</small>}
      {state?.error && <small className="text-danger">{state.error}</small>}
    </div>
  }
  if (state.loading) return <div className="ep-loading"><Spinner size="sm" /> Proposing competitions…</div>
  // Lines proposed for other values are not added: the proposal changed since they were read.
  if (state.path !== path) return <div className="ep-stack">
    <button type="button" className="btn btn-light align-self-start" disabled={disabled || Boolean(disabledReason)} onClick={open}>
      <i className="bx bx-bulb" aria-hidden="true" /> Propose competitions</button>
    <small className="ep-meta">The proposal changed since the competitions were proposed: propose them again.</small>
  </div>
  return <div role="group" aria-label="Proposed competitions" className="ep-card ep-stack ep-gap">
    <b>Proposed competitions</b>
    {!state.lines.length && <span className="ep-meta">The previous edition and the area suggest no competition this proposal does not hold yet.</span>}
    {state.lines.map(line => <label key={line.id} className="ep-filter-option">
      <input type="checkbox" checked={Boolean(ticks[line.id])} aria-label={lineLabel(line, line.rule)}
        onChange={() => setTicks(current => ({ ...current, [line.id]: !current[line.id] }))} />
      <span className="ep-stack"><b>{lineLabel(line, line.rule)}</b><span className="ep-meta">{line.source.detail}</span></span>
    </label>)}
    <span className="ep-generate-actions">
      <button type="button" className="btn btn-light" onClick={() => setState(null)}>Cancel</button>
      <button type="button" className="btn btn-primary" disabled={!chosen.length} onClick={() => { onAdd(chosen.map(proposedCompetition)); setState(null) }}>
        {`Add ${chosen.length} competition${chosen.length === 1 ? "" : "s"}`}</button>
    </span>
  </div>
}
